import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full" style={{
    backgroundColor: '#FFF8F0'
  }} data-id="element-49">
      <div className="max-w-4xl mx-auto px-6 py-12 md:py-18" ref={ref} data-id="element-50">
        {/* Section headline */}
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-51">
          <p className="font-body text-sm uppercase tracking-widest mb-4" style={{
          color: '#B8860B'
        }} data-id="element-52">
            Lo que incluye
          </p>
          <h2 className="font-serif-display font-bold text-3xl md:text-4xl lg:text-5xl leading-tight" style={{
          color: '#1A1A1A'
        }} data-id="element-53">
            El Método Express Alteraciones:{' '}
            <span style={{
            color: '#B8860B'
          }} data-id="element-54">
              7 Arreglos que Pagan la Renta
            </span>
          </h2>
        </motion.div>

        {/* Subtitle */}
        <motion.p className="text-center font-body text-lg md:text-xl max-w-2xl mx-auto mb-8" style={{
        color: '#3D3D3D'
      }} initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-55">
          Lo que vas a lograr <strong data-id="element-56">hoy mismo:</strong>
        </motion.p>

        {/* Three deliverables */}
        <div className="space-y-5" data-id="element-57">
          {/* Deliverable 1 */}
          <motion.div className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: '#FAF3E8',
          border: '1px solid rgba(184, 134, 11, 0.2)'
        }} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-58">
            <div className="flex items-start gap-4" data-id="element-59">
              <CheckCircleIcon className="w-8 h-8 flex-shrink-0 mt-1" style={{
              color: '#D4A017'
            }} aria-hidden="true" data-id="element-60" />
              <div data-id="element-61">
                <h3 className="font-serif-display font-bold text-xl md:text-2xl mb-3" style={{
                color: '#1A1A1A'
              }} data-id="element-62">
                  Dominar los "Top 7"
                </h3>
                <p className="font-body text-lg leading-relaxed" style={{
                color: '#3D3D3D'
              }} data-id="element-63">
                  Los únicos arreglos que la gente realmente paga — Ruedos,
                  Zippers, Ajuste de cintura, y más. Cada uno explicado paso a
                  paso, con fotos y tiempos estimados para que sepas exactamente
                  cuánto vas a ganar.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Deliverable 2 */}
          <motion.div className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: '#FAF3E8',
          border: '1px solid rgba(184, 134, 11, 0.2)'
        }} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.35
        }} data-id="element-64">
            <div className="flex items-start gap-4" data-id="element-65">
              <CheckCircleIcon className="w-8 h-8 flex-shrink-0 mt-1" style={{
              color: '#D4A017'
            }} aria-hidden="true" data-id="element-66" />
              <div data-id="element-67">
                <h3 className="font-serif-display font-bold text-xl md:text-2xl mb-3" style={{
                color: '#1A1A1A'
              }} data-id="element-68">
                  La Tabla Maestra de Precios
                </h3>
                <p className="font-body text-lg leading-relaxed" style={{
                color: '#3D3D3D'
              }} data-id="element-69">
                  Deja de preguntar "¿cuánto cobro?". Te doy los precios exactos
                  por estado (FL, TX, NY, CA, etc.) para que ganes lo justo.
                  Nunca más regales tu trabajo.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Deliverable 3 */}
          <motion.div className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: '#FAF3E8',
          border: '1px solid rgba(184, 134, 11, 0.2)'
        }} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-70">
            <div className="flex items-start gap-4" data-id="element-71">
              <CheckCircleIcon className="w-8 h-8 flex-shrink-0 mt-1" style={{
              color: '#D4A017'
            }} aria-hidden="true" data-id="element-72" />
              <div data-id="element-73">
                <h3 className="font-serif-display font-bold text-xl md:text-2xl mb-3" style={{
                color: '#1A1A1A'
              }} data-id="element-74">
                  Estrategia "Nextdoor"
                </h3>
                <p className="font-body text-lg leading-relaxed" style={{
                color: '#3D3D3D'
              }} data-id="element-75">
                  El texto exacto que debes copiar y pegar para que tus vecinas
                  americanas te traigan bolsas de ropa mañana mismo. Sin
                  complicaciones, sin vergüenza — solo resultados.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}